import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, IconButton, Menu, MenuItem, Table, TableHead, TableBody, TableCell, TableContainer, TableRow, Paper, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import axios from '../utils/axiosConfig';
import ConfirmDialog from './ConfirmDialog';
import ProjectDialog from './ProjectDialog';
import TermsOfServiceDialog from './TermsOfServiceDialog';
import Footer from './Footer';

const ProjectsList = () => {
  const [projects, setProjects] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const termsAccepted = localStorage.getItem('termsAccepted') === 'true';
  const [termsDialogOpen, setTermsDialogOpen] = useState(!termsAccepted);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get('/api/projects');
      setProjects(response.data);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    }
  };

  const handleMenuClick = (event, projectId) => {
    event.stopPropagation();  // Stop propagation to prevent row onClick
    setAnchorEl(event.currentTarget);
    setCurrentProjectId(projectId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditProject = () => {
    navigate(`/projects/${currentProjectId}`);
    handleMenuClose();
  };

  const handleDeleteProject = async () => {
    try {
      await axios.delete(`/api/projects/${currentProjectId}`);
      setConfirmOpen(false);
      fetchProjects();
    } catch (error) {
      console.error('Failed to delete project:', error);
    }
    handleMenuClose();
  };

  const handleConfirmOpen = (event) => {
    event.stopPropagation();
    setConfirmOpen(true);
    handleMenuClose();
  };
  
  const handleCreateProject = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = (newProjectId) => {
    setDialogOpen(false);
    if (newProjectId) {
      navigate(`/projects/${newProjectId}`);
    }
  };

  return (
    <>
      <TermsOfServiceDialog open={termsDialogOpen} onClose={() => setTermsDialogOpen(false)} />
      {termsAccepted && (
        <Paper>
          <Typography variant="h4" style={{ padding: 16 }}>Projects</Typography>
          <Button variant="contained" color="primary" onClick={handleCreateProject}>
            Create New Project
          </Button>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Project Name</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Participants</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {projects.map((project) => (
                  <TableRow key={project.id} onClick={() => navigate(`/projects/${project.id}`)} style={{ cursor: 'pointer' }}>
                    <TableCell>{project.project_name}</TableCell>
                    <TableCell>{new Date(project.created_at).toLocaleDateString()}</TableCell>
                    <TableCell>{project.participants_count}</TableCell>
                    <TableCell>
                      <IconButton onClick={(event) => handleMenuClick(event, project.id)}>
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                      >
                        <MenuItem onClick={handleEditProject}>Edit</MenuItem>
                        <MenuItem onClick={handleConfirmOpen}>Delete</MenuItem>
                      </Menu>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <ProjectDialog open={dialogOpen} onClose={handleDialogClose} isNewProject={true} />
          <ConfirmDialog
            open={confirmOpen}
            onClose={() => setConfirmOpen(false)}
            onConfirm={handleDeleteProject}
            title="Confirm Deletion"
            message="Are you sure you want to delete this project? This will also delete all related data."
          />
        </Paper>
      )}
      <Footer />
    </>
  );
};

export default ProjectsList;